export interface ILazyScriptsService {
	runLazyScripts: () => void
}
interface IScriptCustomParams {
	[key: string]: string
}

interface IScript {
	url?: string
	async?: boolean
	defer?: boolean
	children?: string
	customParams?: IScriptCustomParams
	productionOnly?: boolean
	beforeLoad?: () => Promise<void> | void
}

const loadScript = (script: IScript) => {
	return new Promise<void>((resolve) => {
		;(async () => {
			const scriptElement = document.createElement('script')
			scriptElement.addEventListener('load', () => {
				resolve()
			})
			const config = useRuntimeConfig()
			const isProduction = config.public.environment === 'production'

			const isScriptAlreadyLoaded = document.querySelector(`script[src="${script.url}"]`)

			if (isScriptAlreadyLoaded) {
				resolve()
				return
			}

			if (script.productionOnly && !isProduction) {
				resolve()
				return
			}

			if (script.beforeLoad) {
				try {
					await script.beforeLoad()
				} catch (error) {
					logger.error(error)
				}
			}

			if (script.url) {
				scriptElement.src = script.url
			}

			if (script.async) {
				scriptElement.async = script.async
			}

			if (script.defer) {
				scriptElement.defer = script.defer
			}

			if (script.children) {
				scriptElement.innerHTML = script.children
			}

			if (script.customParams) {
				Object.entries(script.customParams).forEach(([key, value]) => {
					scriptElement.setAttribute(key, value)
				})
			}
			document.head.appendChild(scriptElement)
		})()
	})
}

export const useLazyScriptsService = () => {
	const scripts: IScript[] = [
		// {
		// 	async: true,
		// 	productionOnly: true,
		// 	url: 'https://web.cmp.usercentrics.eu/ui/loader.js',
		// 	customParams: {
		// 		type: 'text/partytown',
		// 		id: 'usercentrics-cmp',
		// 		'data-settings-id': 'XQqurRXXXXmq6t',
		// 	},
		// },
		{
			productionOnly: false,
			async: true,
			url: 'https://unpkg.com/leaflet.fullscreen@1.6.0/Control.FullScreen.js',
			beforeLoad: async () => {
				if (!(window as any).L?.Control) {
					const leaflet = await import('leaflet')
					;(window as any).L = leaflet.default
				}
			},
		},
	]

	const runLazyScripts = async () => {
		await Promise.all(scripts.map((script) => loadScript(script)))
	}

	return {
		runLazyScripts,
	}
}
